export default {
      id: "arrowLeft-usage",
      viewBox: "0 0 6 10",
      url: __webpack_public_path__ + "sprite.1790164512331.svg#arrowLeft-usage",
      toString: function () {
        return this.url;
      }
    }